import { connect } from 'react-redux'
import TripDetailPane from '../../components/trips/trip-detail/TripDetailPane'
import * as tripActions from '../../state/actions/trips'
import * as riderActions from '../../state/actions/riders'
import { getCurrentOrganization } from 'src/state/reducers/organizations'
import { ICoordinates, IStoreState, ITripFilters, IActiveTripResponseV2, IServiceListFilterDTO } from '../../types'
import { clearMap, actionCreators as googleActionCreators } from '../../state/actions/google_map'
import { getGoinzones } from 'src/state/actions/goinzones'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const org = getCurrentOrganization(state)
  const currentTripId = ownProps.match.params.tripId
  const currentTrip = state.trips.items[currentTripId]
  const pastTrips = state.trips.items
  const organizations = state.organizations.currentOrgId
    ? state.organizations.items[state.organizations.currentOrgId]
    : null
  return {
    orgId: org ? org.id : '',
    currentTripId,
    currentTrip,
    pastTrips,
    organizations,
    requestedNumber: state.trips.requestedNumber ? state.trips.requestedNumber : null,
    showDriversPane: state.trips.settings.showMembers,
    auditTrail: currentTrip && currentTrip.tripEditsHistory ? currentTrip.tripEditsHistory : [],
    tripsPerService: state.trips.fetchTotalTripsPerService,
    tripFilters: state.trips.filters,
    riders: state.riders.items,
    zones: state.goinzones.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  const {
    actionCreators: tripActionCreators,
    cancelTrip,
    getUberOperatorDriver,
    getTripById,
    getManyTrips,
    getNearbyDrivers
  } = tripActions

  return {
    fetchRiders: () => {
      return dispatch(riderActions.getMany({ isArchived: true }))
    },
    fetchTotalTripsPerService: (orgId: string, dto: IServiceListFilterDTO) =>
      dispatch(tripActions.getTotalTripsPerService(orgId, dto)),
    cancelTrip: (tripId: string, comment: string) => dispatch(cancelTrip(tripId, comment)),
    getUberOperatorDriver: (tripId: string, orgID: string) => dispatch(getUberOperatorDriver(tripId, orgID)),
    getTripById: (tripId: string) => {
      return dispatch(getTripById(tripId))
    },
    getManyTrips: (params: ITripFilters) => dispatch(getManyTrips(params)),
    setCurrentTrip: (tripId: string) => dispatch(tripActionCreators.setCurrentTrip(tripId)),
    getNearbyDrivers: (location: ICoordinates) => dispatch(getNearbyDrivers(location)),
    setCurrentTripStage: (stage: string) => dispatch(googleActionCreators.setMapViewStrategyStage(stage)),
    clearMap: () => dispatch(clearMap()),
    cloneTrip: async (trip: IActiveTripResponseV2, useTripNotes?: boolean) => {
      const tripClone = { ...trip }
      const pickup = {
        lat: trip.pickupLocation.latitude,
        lng: trip.pickupLocation.longitude
      }
      const dropoff = {
        lat: trip.dropoffLocation.latitude,
        lng: trip.dropoffLocation.longitude
      }
      tripClone.scheduledDropoffTime = undefined
      tripClone.notes = useTripNotes !== false ? tripClone.notes : undefined // choose between displayin rider notes or the custom trip notes
      tripClone.confirmationNumber = undefined
      tripClone.providerOneNumber = undefined
      tripClone.tripRequester = trip.tripRequester
      return Promise.all([
        dispatch(tripActionCreators.cloneTrip(tripClone)),
        dispatch(googleActionCreators.setOrigin(pickup)),
        dispatch(googleActionCreators.setDestination(dropoff)),
        dispatch(googleActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: pickup.lat, lng: pickup.lng }])),
        dispatch(
          googleActionCreators.replaceMarkers('destination', [
            { type: 'destination', lat: dropoff.lat, lng: dropoff.lng }
          ])
        ),
        dispatch(
          tripActionCreators.setEstimatesToTripRequest({
            duration: Math.round(tripClone.estimatedDuration),
            distance: Math.round(tripClone.estimatedDistance)
          })
        ),
        dispatch(
          tripActionCreators.setTripPassengerDetails({
            tripRequestRiders: tripClone.tripsGroupRides,
            disabilityApproved: false,
            attendant: false
          })
        ),
        dispatch(tripActionCreators.updateRiderCount(tripClone.riderCount || 1))
      ])
    },
    hideMembers: () => dispatch(tripActionCreators.hideMembers()),
    showMembers: () => dispatch(tripActionCreators.showMembers()),
    getGoinzones: (orgId: string, serviceId: string) => {
      return dispatch(getGoinzones(orgId, serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripDetailPane)



// WEBPACK FOOTER //
// ./src/containers/trips/TripDetailPane.ts